import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state,
    (state) => state.user
)

export const selectUser = createSelector(
    baseSelector,
    (state) => state.user
)

export const selectUserError = createSelector(
    baseSelector,
    (state) => state.userError
)

export const selectUserLoading = createSelector(
    baseSelector,
    (state) => state.isUserLoading
)

export const selectUserTransactions = createSelector(
    baseSelector,
    (state) => state.transactions
)
export const selectUserTransactionsLoading = createSelector(
    baseSelector,
    (state) => state.isTransactionsLoading
)
export const selectUserTransactionsFirstLoad = createSelector(
    baseSelector,
    (state) => state.transactionsFirstLoad
)

export const selectUserTransactionStores = createSelector(
    baseSelector,
    (state) => state.stores
)
export const selectUserTransactionChecks = createSelector(
    baseSelector,
    (state) => state.checks
)
export const selectTotalPages = createSelector(
    baseSelector,
    (state) => state.totalPages
)
export const selectCurrentPage = createSelector(
    baseSelector,
    (state) => state.page
)
export const selectCurrentTabIndex = createSelector(
    baseSelector,
    (state) => state.tabIndex
)
export const selectAggregates = createSelector(
    baseSelector,
    (state) => state.aggregates
)
export const selectAggregatesError = createSelector(
    baseSelector,
    (state) => state.aggregatesError
)
export const selectAggregatesLoading = createSelector(
    baseSelector,
    (state) => state.isAggregatesLoading
)
export const selectAggregatesFirstLoad = createSelector(
    baseSelector,
    (state) => state.aggregatesFirstLoad
)
export const selectStartDate = createSelector(
    baseSelector,
    (state) => state.startDate
)
export const selectEndDate = createSelector(
    baseSelector,
    (state) => state.endDate
)
export const selectUserHasCard = createSelector(
    baseSelector,
    (state) => state.hasCard
)
export const selectUserCardLoading = createSelector(
    baseSelector,
    (state) => state.isCardLoading
)
export const selectUserCardFirstLoad = createSelector(
    baseSelector,
    (state) => state.cardFirstLoad
)